export default "__VITE_ASSET__BLIOgmwV__"